import {z} from 'zod';

import {DiscountTypeSchema} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

export const BulkEditSupplierDiscountGroupsFormSchema = z
  .object({
    isDiscountTypeEnabled: z.boolean(),
    discountType: DiscountTypeSchema.nullish(),
    isDiscountValueEnabled: z.boolean(),
    discountValue: z.number().min(0).max(100).nullish(),
  })
  .refine((values) => !values.isDiscountValueEnabled || values.discountValue != null, {
    path: ['discountValue'],
    message: i18n.t('errors.field_is_required'),
  })
  .refine((values) => !values.isDiscountTypeEnabled || values.discountType != null, {
    path: ['discountType'],
    message: i18n.t('errors.field_is_required'),
  });

export type BulkEditSupplierDiscountGroupsForm = z.infer<
  typeof BulkEditSupplierDiscountGroupsFormSchema
>;
